import React, { useState } from 'react';
import { generatePath, Link, matchPath, useLocation } from 'react-router-dom';
import Bluebird from 'bluebird';
import { useDispatch } from 'react-redux';
import { Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, Typography, Box } from '@mui/material';
import useNotificationService from '../hooks/useNotificationService';
import routes from '../routes';
import { updateUser } from '../actions/users';
import useActiveSite from '../hooks/useActiveSite';

const SupplementalDocumentReagreement = ({ user }) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const { addErrorNotification } = useNotificationService();
  const location = useLocation();
  const dispatch = useDispatch();
  const site = useActiveSite();
  const supplementalDocSrc = user?.supplemental_doc_src;
  const supplementalDocTitle = user?.supplemental_doc_title;

  const handleAccept = (event) => {
    if (event.target.checked) {
      return Bluebird.try(() => dispatch(updateUser(user.id, { supplemental_doc_accepted: true })))
        .then(() => setDialogOpen(false))
        .catch((error) => addErrorNotification(error, error.message));
    }

    return null;
  };

  if (
    matchPath(location.pathname, {
      path: routes.supplementalDocument,
    })
  ) {
    return null;
  }

  return (
    <Dialog
      open={dialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <DialogTitle>
        {site?.name} has updated {supplementalDocTitle}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">Please read and agree the updated document.</Typography>
        <Box mt={1}>
          <FormControlLabel
            label={
              <>
                I have read, understood, and agree to&nbsp;
                <Link
                  target="_blank"
                  to={generatePath(routes.supplementalDocument, {
                    src: supplementalDocSrc,
                    title: supplementalDocTitle,
                  })}
                >
                  {supplementalDocTitle}
                </Link>
                .
              </>
            }
            required
            control={<Checkbox onChange={handleAccept} />}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default SupplementalDocumentReagreement;
